"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FreeSubscriptionPopup;

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _components = require("components");

var _glamor = require("glamor");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Popup = require("../../components/Popup/Popup");

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contentStyles = (0, _glamor.css)({
  "& a": {
    color: "#26bbff",
    textDecoration: "none"
  }
});
var freeSubscriptionPopup = (0, _glamor.css)({
  position: "fixed",
  top: 0,
  left: 0,
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1,

  "& .backdrop": {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    background: "rgba(0,0,0,0.5)",
    zIndex: 1
  }
});
var licenseAgreement = (0, _glamor.css)({
  display: "flex",
  alignItems: "center"
});
var whatABasicButtonShouldHaveBeen = (0, _glamor.css)({
  background: "#26bbff !important",
  borderColor: "#26bbff !important",
  color: "#242424 !important",
  borderRadius: "4px !important",
  padding: "4.5px 1.5em !important",
  fontFamily: "Roboto !important",
  fontWeigth: "600 !important",
  fontSize: "12px !important",
  lineHeight: "12px !important",
  letterSpacing: "1px !important",
  transition: "transform .2s ease-out",
  "&:disabled": {
    background: "transparent !important",
    borderColor: "#ffffff1a !important",
    color: "#ffffff1a !important",
    cursor: "not-allowed",
    pointerEvents: "none"
  },
  "&:hover": {
    transform: "translate(0, -2px)"
  },
  "&:active": {
    background: "#00aeff !important",
    borderColor: "#00aeff !important"
  }
});
var spacedBetweenHeader = (0, _glamor.css)({
  display: "flex !important",
  alignItems: "center !important",
  justifyContent: "space-between !important"
});
var rightAlignedFooter = (0, _glamor.css)({
  justifyContent: "flex-end !important"
});
var CROSS_SVG = _react2.default.createElement(
  "svg",
  { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
  _react2.default.createElement("path", {
    d: "M1 1L11 11M11 1L1 11",
    stroke: "white",
    "stroke-opacity": "0.5",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
);
var ERROR_ICON_SVG = _react2.default.createElement(
  "svg",
  { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
  _react2.default.createElement("path", {
    d: "M7.125 9C7.125 8.65482 7.40482 8.375 7.75 8.375H9C9.34518 8.375 9.625 8.65482 9.625 9V12.75C9.625 13.0952 9.34518 13.375 9 13.375C8.65482 13.375 8.375 13.0952 8.375 12.75V9.625H7.75C7.40482 9.625 7.125 9.34518 7.125 9Z",
    fill: "#FFC229"
  }),
  _react2.default.createElement("path", {
    d: "M9 6.5C9.46024 6.5 9.83333 6.1269 9.83333 5.66667C9.83333 5.20643 9.46024 4.83333 9 4.83333C8.53976 4.83333 8.16667 5.20643 8.16667 5.66667C8.16667 6.1269 8.53976 6.5 9 6.5Z",
    fill: "#FFC229"
  }),
  _react2.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.875 9C0.875 4.51269 4.51269 0.875 9 0.875C13.4873 0.875 17.125 4.51269 17.125 9C17.125 13.4873 13.4873 17.125 9 17.125C4.51269 17.125 0.875 13.4873 0.875 9ZM9 2.125C5.20304 2.125 2.125 5.20304 2.125 9C2.125 12.797 5.20304 15.875 9 15.875C12.797 15.875 15.875 12.797 15.875 9C15.875 5.20304 12.797 2.125 9 2.125Z",
    fill: "#FFC229"
  })
);

function FreeSubscriptionPopup(_ref) {
  var user = _ref.user,
      isSettingUp = _ref.isSettingUp,
      allDone = _ref.allDone,
      errorMessage = _ref.errorMessage,
      eulaChecked = _ref.eulaChecked,
      selectedPlan = _ref.selectedPlan,
      onClose = _ref.onClose,
      onEulaCheckChange = _ref.onEulaCheckChange,
      onCreateSubscription = _ref.onCreateSubscription;

  var eulasAccepted = user && user.eulasAccepted || [];
  var isEpicContentLisenceAlreadyAccepted = eulasAccepted.includes("epic_content");

  return _react2.default.createElement(
    "div",
    { className: freeSubscriptionPopup },
    _react2.default.createElement(
      _Popup2.default,
      null,
      _react2.default.createElement(
        _Popup2.default.Header,
        null,
        _react2.default.createElement(
          "div",
          { className: spacedBetweenHeader },
          _react2.default.createElement(
            "span",
            null,
            allDone ? "Success" : "Welcome"
          ),
          _react2.default.createElement(
            "span",
            { onClick: onClose },
            CROSS_SVG
          )
        )
      ),
      _react2.default.createElement(
        _Popup2.default.Content,
        null,
        allDone ? _react2.default.createElement(
          "div",
          null,
          "We\u2019ve set you up with a ",
          selectedPlan,
          " plan."
        ) : _react2.default.createElement(
          "div",
          { className: contentStyles },
          _react2.default.createElement(
            "div",
            null,
            selectedPlan === "Indie" && "You qualify for an Indie plan if you generate less than $2,000,000 in funding or\n                yearly revenue.",
            selectedPlan === "Personal" && "You qualify for a " + selectedPlan + " plan only if you are an individual with under " + { Personal: "$100K", Indie: "$200K" }[selectedPlan] + " in funding or yearly revenue.",
            _react2.default.createElement("br", null),
            _react2.default.createElement("br", null),
            "For more information on the above threshold, check out our",
            " ",
            _react2.default.createElement(
              "a",
              { href: "https://www.unrealengine.com/en-US/eula/content", target: "_blank" },
              "Content License Agreement"
            ),
            "."
          ),
          _react2.default.createElement("br", null),
          !isEpicContentLisenceAlreadyAccepted && _react2.default.createElement(
            "div",
            { className: licenseAgreement },
            _react2.default.createElement(_Checkbox2.default, { name: "eula", checked: eulaChecked, onChange: onEulaCheckChange }),
            _react2.default.createElement(
              "span",
              null,
              "I agree to the",
              " ",
              _react2.default.createElement(
                "a",
                { target: "_blank", href: "https://www.unrealengine.com/en-US/eula/content" },
                "Content License Agreement"
              ),
              "."
            )
          ),
          errorMessage && _react2.default.createElement(
            "div",
            {
              style: {
                marginTop: 24,
                color: "#FFC229",
                display: "flex",
                alignItems: "flex-start",
                gap: 8
              } },
            ERROR_ICON_SVG,
            errorMessage
          )
        )
      ),
      _react2.default.createElement(
        _Popup2.default.Footer,
        { className: rightAlignedFooter },
        _react2.default.createElement(_components.Button, {
          label: allDone ? "Get Started" : "Continue",
          disabled: !isEpicContentLisenceAlreadyAccepted && !eulaChecked || isSettingUp,
          className: whatABasicButtonShouldHaveBeen,
          onClick: function onClick() {
            if (allDone) {
              onClose();
              window.location.reload();
            } else {
              onCreateSubscription(isEpicContentLisenceAlreadyAccepted);
            }
          }
        })
      )
    ),
    _react2.default.createElement("div", { className: "backdrop" })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Pricing2/FreeSubscriptionPopup.jsx
// module id = 2641
// module chunks = 0